import logo from './logo.svg';
import './App.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PartnersSection from './LandingSection/PartnersSection';
import ProjectShowcase from './LandingSection/ProjectShowcase';
import TechSolutions from './LandingSection/TechSolutions';
import TechStack from './LandingSection/TechStack';
import CallToAction from './LandingSection/CallToAction';
import Footer from './Components/Footer';
import HeroSection from './LandingSection/HeroSection';
import AISection from './LandingSection/AISection';
import Header from './Components/Header';
import CaseStudies from './Pages/CaseStudies/CaseStudies';
import AboutPage from './Pages/About/AboutPage';
import CustomCursor from './Components/CustomCursor';
import CareerPage from './Pages/Career/CareerPage';
import ContactUs from './Pages/ContactUs/ContactUs';
import Service from './Pages/Services/Service';
import MentalHeathCaseStudies from './Pages/CaseStudies/IndividualPage/MentalHealthCaseStudies/MentalHealthCaseStudies';
import MentalHealthCaseStudiesPage from './Pages/CaseStudies/IndividualPage/MentalHealthCaseStudies/MentalHealthCaseStudiesPage';
import { TimelineDemo } from './Pages/CaseStudies/IndividualPage/MentalHealthCaseStudies/TimelineDemo';
import ModernBankingCaseStudyPage from './Pages/CaseStudies/IndividualPage/ModernBankingCaseStudy/ModernBankingCaseStudyPage';
import DocumentManagementCaseStudyPage from './Pages/CaseStudies/IndividualPage/DocumentManagementCaseStudy/DocumentManagementCaseStudyPage';
import EHRCaseStudyPage from './Pages/CaseStudies/IndividualPage/EHRCaseStudy/EHRCaseStudyPage';
import RealtimeAdvertisingPage from './Pages/CaseStudies/IndividualPage/RealtimeAdvertisingCaseStudy/RealtimeAdvertisingPage';
import TrafficManagementPage from './Pages/CaseStudies/IndividualPage/TrafficManagementCaseStudy/TrafficManagementPage';
import ScrollToTop from './Components/ScrollToTop';



function App() {
  return (
     <>
       <Router>
        <ScrollToTop />
        <Routes>
           <Route path="/" element={
            <>
            <Header></Header>
            <HeroSection/>
            <AISection></AISection>
            <PartnersSection></PartnersSection>
            <ProjectShowcase></ProjectShowcase>
            <TechSolutions></TechSolutions>
            <TechStack></TechStack>
            <CallToAction></CallToAction>
            <Footer></Footer>
            </>
            } />

             <Route path="/case-studies" element={
            <>
            <Header bgColor="#242424"/>
            <CaseStudies></CaseStudies>
            <CallToAction></CallToAction>
            <Footer></Footer>
            </>
            } />

            <Route path="/about-us" element={
              <>
            <AboutPage></AboutPage>
              </>
            } />

            {/* <Route path="/career" element={
              <>
              <CareerPage/>
              </>
            } /> */}

             <Route path="/contact" element={
              <>
              <ContactUs/>
              </>
            } />

              <Route path="/services" element={
              <>
              <Service/>
              </>
            } />

             <Route path="/case-studies-mental-health" element={
              <>
               <MentalHealthCaseStudiesPage></MentalHealthCaseStudiesPage>
              </>
            } />

              <Route path="/case-studies-mental-health-demo" element={
              <>
               <TimelineDemo></TimelineDemo>
              </>
            } />

             <Route path="/case-studies-modern-banking" element={
              <>
               <ModernBankingCaseStudyPage></ModernBankingCaseStudyPage>
              </>
            } />

             <Route path="/case-studies-document-management" element={
              <>
               <DocumentManagementCaseStudyPage></DocumentManagementCaseStudyPage>
              </>
            } />

             <Route path="/case-studies-academic-ehr" element={
              <>
               <EHRCaseStudyPage></EHRCaseStudyPage>
              </>
            } />

             <Route path="/case-studies-realtime-advertising" element={
              <>
               <RealtimeAdvertisingPage></RealtimeAdvertisingPage>
              </>
            } />

             <Route path="/case-studies-traffic-management" element={
              <>
               <TrafficManagementPage></TrafficManagementPage>
              </>
            } />

       </Routes>
      </Router>

      
      
   </>
  );
}

export default App;
